/**
 * Contratto unico della revisione calendario.
 *
 * Ogni superficie (Feed, barra globale, drawer) deve usare questi codici e
 * non reinterpretare autonomamente gli inviti. `confirmed` e' uno stato
 * terminale positivo. `attendance_pending` identifica invece un impegno gia'
 * riconosciuto come reale per cui Michele non ha ancora deciso se partecipare.
 */
export const CALENDAR_REVIEW_CODES = {
  CONFIRMED: 'confirmed',
  PENDING_CONFIRMATION: 'pending_confirmation',
  ATTENDANCE_PENDING: 'attendance_pending',
  PARSING_ERROR: 'parsing_error',
  INTERPRETATION_ERROR: 'interpretation_error',
} as const;

export type CalendarReviewCode = typeof CALENDAR_REVIEW_CODES[keyof typeof CALENDAR_REVIEW_CODES];

export const CALENDAR_REVIEW_LABELS: Record<CalendarReviewCode, string> = {
  confirmed: 'Appuntamento reale e confermato',
  pending_confirmation: 'Proposta da verificare',
  attendance_pending: 'Impegno reale, partecipazione da decidere',
  parsing_error: 'Errore di lettura dell’invito',
  interpretation_error: 'Interpretazione da verificare',
};

export const CALENDAR_REVIEW_ENTITY_KINDS = {
  EVENT: 'event',
  APPOINTMENT: 'appointment',
} as const;

export type CalendarReviewEntityKind = typeof CALENDAR_REVIEW_ENTITY_KINDS[keyof typeof CALENDAR_REVIEW_ENTITY_KINDS];

/** Il tipo arriva dal Meeting canonico: la UI non prova a dedurlo dal titolo. */
export function calendarReviewEntityKindFromMeetingType(meetingType: unknown): CalendarReviewEntityKind {
  return String(meetingType ?? '').trim().toLocaleLowerCase('it-IT') === 'evento'
    ? CALENDAR_REVIEW_ENTITY_KINDS.EVENT
    : CALENDAR_REVIEW_ENTITY_KINDS.APPOINTMENT;
}

export const CALENDAR_REVIEW_ENTITY_LABELS: Record<CalendarReviewEntityKind, string> = {
  event: 'Evento',
  appointment: 'Appuntamento',
};

export function calendarReviewCodeFromDiagnostic(diagnostic: string | null | undefined): CalendarReviewCode {
  return diagnostic === 'text_invite_unresolved' || diagnostic === 'text_time_unresolved'
    ? CALENDAR_REVIEW_CODES.INTERPRETATION_ERROR
    : CALENDAR_REVIEW_CODES.PARSING_ERROR;
}

export const CALENDAR_REVIEW_OPEN_EVENT = 'experviser:calendar-review-open';
